<template>
  <div style="width: 100%">
    <div>
      <el-row :gutter="16" class="el-row">
        <el-col :span="6">

          <el-date-picker
              style="width: 100%"
              v-model="dateValue"
              type="datetimerange"
              align="right"
              :picker-options="pickerOptions"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>

        </el-col>

        <el-col :span="3">
          <el-select v-model="projectValue" placeholder="项目" @change="getServiceCatalog">
            <el-option
                v-for="item in projectCatalog"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-select v-model="serviceValue" placeholder="服务" @change="getAlertCatalog">
            <el-option
                v-for="item in serviceCatalog"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-select v-model="alertValue" placeholder="警报">
            <el-option
                v-for="item in alertCatalog"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>


        <el-col :span="3">
          <el-select v-model="levelValue" placeholder="警报等级">
            <el-option
                v-for="item in levelMap"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="3">
          <el-input v-model="key" placeholder="请输入关键字"></el-input>

        </el-col>

        <el-col :span="3">
          <el-button type="primary" size="medium" @click="search">搜索</el-button>

        </el-col>

      </el-row>
    </div>
    <div style="margin: 40px 0;"></div>


    <div id="app" v-show="resultVisible">
      <v-chart class="my-chart" :options="option" v-if="resultVisible" style="width: 100%"/>
    </div>

    <el-table
        :row-key="getRowKeys"
        :expand-row-keys="expands"
        @row-click="clickRowHandle"
        stripe

        v-show="resultVisible"
        :data="tableData"
        style="width: 100%">
      <!--            <el-table-column-->
      <!--                    prop="messageID"-->
      <!--                    label="消息ID"-->
      <!--                    width="80">-->
      <!--            </el-table-column>-->


      <el-table-column type="expand"
                       style="width: 5%">
        <template slot-scope="scope">
          <div style="padding-left: 60px;">

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">环境</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.env || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">主机</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.host || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">项目名称</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.projectName || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">服务名称</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.serviceName || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">警报名称</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.alertName || "null" }}</td>
            </tr>


            <tr>
              <td class="css-1d24gbv-logs-row-details__label">重置规则信息</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.alertRuleInfo || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">消息标题</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.title || "null" }}</td>
            </tr>

            <tr>
              <td class="css-1d24gbv-logs-row-details__label">消息正文</td>
              <td class="css-hh1wya-wordBreakAll">{{ scope.row.message || "null" }}</td>
            </tr>


          </div>
        </template>
      </el-table-column>

      <el-table-column
          style="width: 5%"
          prop="level"
          label="消息等级">
        <template slot-scope="scope">
          <el-tag
              :type="(scope.row.level===levelMap[1].label ? 'info' : (scope.row.level===levelMap[2].label ? '' : (scope.row.level===levelMap[3].label ? 'warning' : (scope.row.level===levelMap[4].label ? 'danger': 'danger'))))"
              class="keyWordTag">
            {{ scope.row.level }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column
          prop="createTime"
          label="消息时间"
          style="width: 10%">
      </el-table-column>

      <el-table-column
          :show-overflow-tooltip="true"
          prop="title"
          label="消息标题"
          style="width: 30%">
      </el-table-column>
      <el-table-column
          :show-overflow-tooltip="true"
          prop="message"
          label="消息正文"
          style="width: 30%">
      </el-table-column>

      <el-table-column
          prop="status"
          label="消息状态"
          style="width: 10%">

        <template slot-scope="scope">
          <el-tag
              :type="(scope.row.status===statusMap[1] ? 'info' :(scope.row.status===statusMap[2] ? 'success' : (scope.row.status===statusMap[3] ? 'danger':'danger')))"
              class="keyWordTag">
            {{ scope.row.status }}
          </el-tag>
        </template>

      </el-table-column>
      <el-table-column
          prop="type"
          label="消息类型"
          style="width: 10%">
        <template slot-scope="scope">
          <el-tag
              :type="(scope.row.type===typeMap[1] ? '' : (scope.row.type===typeMap[2] ? 'danger': 'danger'))"
              class="keyWordTag">
            {{ scope.row.type }}
          </el-tag>
        </template>

      </el-table-column>

    </el-table>
    <div style="text-align: center;margin-top: 30px;" v-show="resultVisible">
      <el-pagination
          background
          layout="prev, pager, next"
          :total="pageTotal"
          @current-change="currentChange">
      </el-pagination>
    </div>


  </div>
</template>

<script>

import {Apis} from "@/api";

import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/chart/bar"

export default {
  name: "App",
  components: {
    "v-chart": ECharts
  },

  data() {
    // let _minTime = null
    // let _maxTime = null

    return {
      // 获取row的key值
      getRowKeys(row) {
        return row.messageID;
      },
      // 要展开的行，数值的元素是row的key值
      expands: [],

      resultVisible: false,

      pageSize: 10,
      pageIndex: 0,
      pageTotal: 0,

      option: {
        title: {
          text: '告警走势图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      },

      pickerOptions: {
        //禁用当前时间之后的时间和30天天以前的时间
        //当前时间:yy-mm-dd hh:mm:ss
        //可选时间:[yy-mm-dd(再减去30天) 00：00：00,yy-mm-dd 23:59:59]
        disabledDate(date) {
          const maxTime = new Date().setHours(23, 59, 59, 0);

          const timeRange = 30 * 24 * 60 * 60 * 1000  // 30天
          const minTime = new Date().setHours(0, 0, 0, 0) - timeRange;

          if (date.getTime() > maxTime || date.getTime() < minTime) {
            return true;//禁用
          }
          return false;
        },
        shortcuts: [{
          text: '最近24小时',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      statusMap: {'1': "已记录", "2": "已通知", "3": "通知失败"},
      typeMap: {'1': "正常触发", '2': "规则触发"},

      levelMap: [{
        value: -1,
        label: '所有等级'
      },
        {
          value: 1,
          label: '信息'
        }, {
          value: 2,
          label: '警告'
        }, {
          value: 3,
          label: '错误'
        }, {
          value: 4,
          label: '致命'
        }],

      projectCatalog: [{
        "value": -1,
        "label": "所有项目"
      },],
      projectValue: "",

      serviceCatalog: [],
      serviceValue: "",

      alertCatalog: [],
      alertValue: "",

      dateValue: [],
      levelValue: "",
      key: "",

      tableData: []

    }

  },

  methods: {

    clickRowHandle(row, column, event) {
      console.log(row)
      if (this.expands.includes(row.messageID)) {
        this.expands = this.expands.filter(val => val !== row.messageID);
      } else {
        this.expands.push(row.messageID);
      }
    },

    //-------------util------------------//
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    dateFormat(timestamp, c) {
      const time = new Date(timestamp);    //先将时间戳转为Date对象，然后才能使用Date的方法
      const year = time.getFullYear(),
          month = time.getMonth() + 1,
          day = time.getDate(),
          hour = time.getHours(),
          minute = time.getMinutes(),
          second = time.getSeconds();
      return year + '-' + this.add0(month) + '-' + this.add0(day) + c + this.add0(hour) + ':' + this.add0(minute) + ':' + this.add0(second)
    },

    //根据页面下表获取列表数据
    async currentChange(currentPage) {
      this.pageIndex = currentPage

      //转换时间格式
      const startDate = this.dateFormat(this.dateValue[0], ' ');
      const endDate = this.dateFormat(this.dateValue[1], ' ');

      const re = await Apis.Message.MessageSearchForList(this.projectValue, this.serviceValue, startDate, endDate, this.alertValue, this.levelValue, this.key, this.pageSize, this.pageIndex)
      this.tableData = re.data || []

    },
    //---------------- backend-----------------//
    async getProjectCatalog() {
      const response = await Apis.Message.ProjectCatalog()
      this.projectCatalog = response.data || []

    },

    async getServiceCatalog() {
      const response = await Apis.Message.ServiceCatalog(this.projectValue)
      this.serviceCatalog = response.data || []

      //重置
      this.serviceValue = ""
      this.alertValue = ""
      this.levelValue = ""
    },

    async getAlertCatalog() {
      const response = await Apis.Message.AlertCatalog(this.projectValue, this.serviceValue)
      this.alertCatalog = response.data || []

      //重置
      this.alertValue = ""
      this.levelValue = ""

    },
    resetData() {
      this.dateValue = []
      this.projectValue = ""
      this.serviceValue = ""
      this.alertValue = ""
      this.levelValue = ""
      this.key = ""
    },

    async search() {
      if (this.dateValue === [] || this.projectValue === "" || this.serviceValue === "" || this.alertValue === "" || this.levelValue === "") {
        this.$message.error("时间范围，项目，服务，等级都是必选");
        return
      }

      //转换时间格式
      const startDate = this.dateFormat(this.dateValue[0], ' ');
      const endDate = this.dateFormat(this.dateValue[1], ' ');
      // console.log(startDate)
      // console.log(endDate)

      const response = await Apis.Message.MessageSearchForGraph(this.projectValue, this.serviceValue, startDate, endDate, this.alertValue, this.levelValue, this.key)

      // console.log(response)
      //重新绘制图表
      this.option = {
        title: {
          text: '警报数量图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      }
      this.option.xAxis.data = response.data.dateList ?? []
      this.option.legend.data = response.data.keyList ?? []
      this.option.series = response.data.series ?? []

      //让图表和列表可见
      this.resultVisible = true

      //每次搜索都重置一下列表数据
      this.tableData = []
      this.pageTotal = 0
      this.pageIndex = 1

      //列表需要获取第一页数据
      this.pageTotal = response.data.length
      await this.currentChange(1)

      //拼接成指定链接
      this.changeUrl(this.dateValue[0].getTime(), this.dateValue[1].getTime(), this.projectValue, this.serviceValue, this.alertValue, this.levelValue, this.key)

    },

    changeUrl(startDate, endDate, projectID, serviceID, alertID, level, key) {

      //截取xxx.xxx.xxx/search这一段url字符串,避免重复拼接
      const url = location.pathname
      const str = "search";
      const start = url.indexOf(str);
      const result = url.substring(0, start + str.length);

      const URL = result + '/' + startDate + '/' + endDate + '/' + projectID + '/' + serviceID + '/' + alertID + '/' + level + '/' + key
      history.pushState({url: URL, title: document.title}, document.title, URL)
    },
  },

  created: async function () {
    await this.getProjectCatalog()

    //重置查询的条件
    this.resetData()

    //执行从链接识别逻辑
    //当链接中存在查询条件的数据时才进入
    if (this.$route.params.startDate !== undefined) {

      //解析路由参数
      const startDate = parseInt(this.$route.params.startDate);
      const endDate = parseInt(this.$route.params.endDate);
      const projectID = parseInt(this.$route.params.projectID);
      const serviceID = parseInt(this.$route.params.serviceID);
      const alertID = parseInt(this.$route.params.alertID);
      const level = parseInt(this.$route.params.level);
      const key = (this.$route.params.key);

      this.dateValue[0] = new Date(startDate)
      this.dateValue[1] = new Date(endDate)

      //回填项目名
      this.projectValue = projectID

      //回填服务名称
      await this.getServiceCatalog()
      this.serviceValue = serviceID

      //回填警报名称
      await this.getAlertCatalog()
      this.alertValue = alertID

      //回填等级名称
      this.levelValue = level

      //回填key
      this.key = key

      //自动查询
      await this.search()

      //当key没有填的时候，避免url后加上undefined
      if (this.key === undefined) {
        this.key = ""
      }
      this.changeUrl(this.dateValue[0].getTime(), this.dateValue[1].getTime(), this.projectValue, this.serviceValue, this.alertValue, this.levelValue, this.key)

    }

  },
}

</script>


<style scoped>
.my-chart {
  width: 1500px;
  height: 500px;
}

el-row {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap
}

.el-card {
  min-width: 100%;
  height: 100%;
  margin-right: 20px;
  transition: all .5s;
}

.css-1d24gbv-logs-row-details__label {
  max-width: 30em;
  min-width: 20em;
  padding: 0px 8px;
  overflow-wrap: break-word;
}

.css-hh1wya-wordBreakAll {
  word-break: break-all;
}

</style>
<style lang="css">

.el-tooltip__popper {
  font-size: 14px;
  max-width: 50%
}

</style>